// extracted by mini-css-extract-plugin
export default {"custom-button":"styles-module__custom-button___Cyxax","blue":"styles-module__blue___UK06J"};